'use client'

import {AnimateOnScroll, Box, Faq, Services, TrustedProducts} from '@blocks'
import {sitePageCanvasBackgroundHex} from '@constants'
import type {ReactNode} from 'react'

export const HomePageSections = () => {
   return (
      <>
         <AnimateOnScroll>
            <Services />
         </AnimateOnScroll>
         <AnimateOnScroll>
            <TrustedProducts tone={'blue'} />
         </AnimateOnScroll>
         <AnimateOnScroll>
            <Faq categoryPriority={'general-questions'} />
         </AnimateOnScroll>
      </>
   )
}

type HomePageWithHeroPayload = Readonly<{
   hero: ReactNode
}>

export const HomePageWithHero = ({hero}: HomePageWithHeroPayload) => {
   return (
      <Box bg={sitePageCanvasBackgroundHex}>
         {hero}
         <HomePageSections />
      </Box>
   )
}
